// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ManifestTripMonitor from '../../components/administration/manifests/ManifestTripMonitor';

const MonitorViajePage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ManifestTripMonitor
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de Monitoreamiento de Viaje', newOrder);
                }}
            />
        </Box>
    );
};

export default MonitorViajePage;
